import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventoryBean,
  SkuBatchInventoryPageListPrintRequest,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import {
  DEFAULT_WAREHOUSE,
} from "../ds/App_Constants.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";

import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
  NumberFormatInputbox,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import CustomTable from "../gui_components/CustomTable.js";
class SkuBatchInventory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Sku Batch Inventory Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new SKUBatchInventorySearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseReceiptModule: false,
      moduleForPopup: [],
      warehouses: [],
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteCustomerList: true,
      customerPageListForAutoCompleteList: new Array(),
      skuBatchInventoryBean: new SKUBatchInventoryBean(),
      isShowRollSkuPopup: false,
      isDisableFields: false,
      isCollapsible_open: true,
      is3PL: false,
      fabricStyleData: new FabricStyleBean(),
      showAutoCompleteLogisticCustomerList: false,
      logisticCustomerPageListForAutoCompleteList: new Array(),
      totalPages: 0,
      totalNumberOfpallets: 0,
    };
    this.fabricCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }

    let criteria = this.state.criteria;
    criteria.locationCode = DEFAULT_WAREHOUSE;
    this.setState({
      criteria: criteria,
    });
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let criteria = this.state.criteria;
    // if (!this.state.is3PL) {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      // "FabricStyle"
      this.state.is3PL ? "Item" : "FabricStyle",
      this.state.is3PL ? criteria.logisticCustomerCode : ""
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    // }

    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (this.state.is3PL) {
      if (
        isEmptyString(data.logisticCustomerCode) &&
        isEmptyString(data.fabricStyleCode)
      ) {
        let errMsg = "Customer/Item is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    } else {
      if (isEmptyString(data.fabricStyleCode)) {
        let errMsg = "Fabric is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.isExcludeNonWarehouseInventory = true;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 500; // Specific for this Inquiry
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });

    // if (!isEmptyString(criteria.fabricStyleCode)) {
    let isValid = false;
    isValid = this.validate(criteria);
    if (isValid) {
      this.loadSkuBatchInventoryInquiryList(listRequest);
    }
    // } else {
    //   let errMsg = "";
    //   if (!this.state.is3PL) {
    //     errMsg = "FabricStyleCode is Required";
    //   } else {
    //     // errMsg = "ItemCode is Required";
    //   }
    //   let errList = [];
    //   errList.push(errMsg);
    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //     isLoading: false,
    //     isShowProgressBarPopup: false,
    //     progressLoadingText: "",
    //   });
    // }
  };
  loadSkuBatchInventoryInquiryList = (listRequest) => {
    if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        listRequest,
        this.loadSkuBatchInventoryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadSkuBatchInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let skuBatchDataList = [];
      let totalNumberOfpallets = 0;
      let pageList = this.state.pageList;
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        let resultList = [];
        resultList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        totalNumberOfpallets =
          response.data.skuBatchInventoryPageList.totalNumberOfpallets;
        pageList.currentPage =
          response.data.skuBatchInventoryPageList.currentPage;
        pageList.pageSize = response.data.skuBatchInventoryPageList.pageSize;
        pageList.totalCount =
          response.data.skuBatchInventoryPageList.totalCount;
        this.state.totalPages = Math.ceil(
          pageList.totalCount / pageList.pageSize
        );
        resultList.map((ln) => {
          if (ln.onHandQuantity != 0) {
            skuBatchDataList.push(ln);
          }
        });
        this.setState({ isShowPDFButton: true, isShowExcelButton: true });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: skuBatchDataList,
        isCollapsible_open: false,
        isShowColorLookup: false,
        pageList: pageList,
        totalNumberOfpallets: totalNumberOfpallets,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateSkuBatchInventoryReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 20;
    // pageInput.currentPage = 1;
    let listRequest = new SkuBatchInventoryPageListPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.SkuBatchInventoryInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateBatchInventorySummaryDataPrintReport(
          listRequest,
          this.generateSkuBatchInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.SkuBatchInventoryInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateBatchInventorySummaryDataPrintReport(
          listRequest,
          this.generateSkuBatchInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateSkuBatchInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.logisticCustomerName = "";
    criteria.locationCode = DEFAULT_WAREHOUSE;
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "FabricStyle",
      criteria.logisticCustomerCode
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      showAutoCompleteLogisticCustomerList: false,
      logisticCustomerPageListForAutoCompleteList: new Array(),
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.logisticCustomerName = "";
    criteria.locationCode = DEFAULT_WAREHOUSE;
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "FabricStyle",
      criteria.logisticCustomerCode
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      showAutoCompleteLogisticCustomerList: false,
      logisticCustomerPageListForAutoCompleteList: new Array(),
      totalPages: 0,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateSkuBatchInventoryReport(1);
  };
  generateExcel = () => {
    this.generateSkuBatchInventoryReport(2);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    // let totalPages = 0;
    // totalPages = Math.ceil(totalCount / pageSize);
    // this.state.totalPages = totalPages;
    // let totalPages = totalCount / pageSize;
    // totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(this.state.totalPages);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewPOModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  rollSkuNumberOnClick = (e, val, rowData) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.state.is3PL
          ? "Fetching Inventory#..."
          : "Fetching Roll SKU#...",
      });
      let skuBatchInventoryBeanList = new SKUBatchInventoryBean();
      skuBatchInventoryBeanList.fabricStyleCode = rowData.fabricStyleCode;
      skuBatchInventoryBeanList.fabricStyleName = rowData.fabricStyleName;
      skuBatchInventoryBeanList.fabricStyleColorCode =
        rowData.fabricStyleColorCode;
      skuBatchInventoryBeanList.widthCode = rowData.widthCode;
      skuBatchInventoryBeanList.rollSkuNumber = rowData.rollSkuNumber;
      skuBatchInventoryBeanList.skuNumber = rowData.skuNumber;
      skuBatchInventoryBeanList.aisleInfoText = rowData.aisleInfoText;
      skuBatchInventoryBeanList.purchaseOrderNumber =
        rowData.purchaseOrderNumber;
      skuBatchInventoryBeanList.purchaseOrderReceiptNumber =
        rowData.purchaseOrderReceiptNumber;
      skuBatchInventoryBeanList.containerNumber = rowData.containerNumber;
      skuBatchInventoryBeanList.receivedDate = rowData.receivedDate;
      skuBatchInventoryBeanList.rollNumber = rowData.rollNumber;
      skuBatchInventoryBeanList.vendorBatchNumber = rowData.vendorBatchNumber;
      skuBatchInventoryBeanList.vendorSkuNumber = rowData.vendorSkuNumber;
      skuBatchInventoryBeanList.etaDate = rowData.etaDate;
      skuBatchInventoryBeanList.reserveCustomerCode =
        rowData.reserveCustomerCode;
      skuBatchInventoryBeanList.reserveCustomerName =
        rowData.reserveCustomerName;
      skuBatchInventoryBeanList.landedCost = rowData.landedCost;
      skuBatchInventoryBeanList.fobCost = rowData.fobCost;
      skuBatchInventoryBeanList.cost = rowData.cost;
      skuBatchInventoryBeanList.onHandQuantity = rowData.onHandQuantity;
      skuBatchInventoryBeanList.receivedQuantity = rowData.receivedQuantity;
      skuBatchInventoryBeanList.locationCode = rowData.locationCode;
      this.setState({ skuBatchInventoryBean: skuBatchInventoryBeanList });
      this.setState({
        isShowRollSkuPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowRollSkuPopup: isShowPopup,
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        criteria.colorCode = "";
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    const criteria = this.state.criteria;
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    searchCriteria.logisticCustomerCode = criteria.logisticCustomerCode;
    const pageList = new RestPageListBean();
    pageList.pageSize = 100;
    const input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStylePageList) &&
      !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let criteria = this.state.criteria;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          // if (this.state.is3PL) {
          //   if (fabricStyle.customerCode == criteria.logisticCustomerCode) {
          //     let simpleItemBean = {
          //       code: fabricStyle.fabricStyleCode,
          //       description: fabricStyle.fabricStyleName,
          //     };
          //     simpleAutoCompleteList.push(simpleItemBean);
          //   }
          // } else {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
          // }
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  customerCodeOnChange = (e) => {
    let reserveCustomerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(reserveCustomerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.reserveCustomerCode = "";
      criteria.reserveCustomerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reserveCustomerCode" &&
      showAutoCompleteList === true &&
      reserveCustomerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.reserveCustomerName = customerData.description;
        criteria.reserveCustomerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };

  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  onLogisticCustomerChange = (e) => {
    let logisticCustomerCode = e.target.value;
    this.state.showAutoCompleteLogisticCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLogisticCustomerList;
    if (isEmpty(logisticCustomerCode)) {
      this.state.showAutoCompleteLogisticCustomerList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteLogisticCustomerList;
      let temp_criteria = this.state.criteria;
      temp_criteria.logisticCustomerCode = "";
      temp_criteria.logisticCustomerName = "";
      temp_criteria.fabricStyleCode = "";
      temp_criteria.fabricStyleName = "";
      temp_criteria.colorCode = "";
      let suggestion = [];
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        this.state.is3PL ? "Item" : "FabricStyle",
        temp_criteria.logisticCustomerCode
      );
      this.setState({
        fabricLookupHandler: fabricLookupHandler,
        isShowColorLookup: false,
      });
      this.setState({
        showAutoCompleteLogisticCustomerList: showAutoCompleteList,
        criteria: temp_criteria,
        logisticCustomerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "logisticCustomerCode" &&
      showAutoCompleteList === true &&
      logisticCustomerCode !== ""
    ) {
      this.readLogisticCustomerBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
    //this.readLogisticCustomer(logisticCustomerCode);
  };

  readLogisticCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByLogisticCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByLogisticCustomerCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerPageList) &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerList = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerList.length > 0 && customerList != null) {
        customerList.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        logisticCustomerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };

  readLogisticCustomerResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.customer)) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.logisticCustomerCode = customerData.code;
      criteria.logisticCustomerName = customerData.description;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      this.setState({ criteria: criteria, isShowColorLookup: false });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        // "Item",
        this.state.is3PL ? "Item" : "FabricStyle",
        criteria.logisticCustomerCode
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
  };

  readLogisticCustomer = (logisticCustomerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = logisticCustomerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readLogisticCustomerResponse,
      this.errorCallBack
    );
  };
  logisticCustomerEnterKeyEventHandler = (e) => {
    let logisticCustomerCode = e.target.value;
    this.readLogisticCustomer(logisticCustomerCode);
    this.setState({
      logisticCustomerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLogisticCustomerList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteLogisticCustomerList: showAutoCompleteList,
    });
  };
  graphValueProvider = (rowData) => {
    if (
      parseFloat(rowData.onHandQuantity) >= parseFloat(rowData.receivedQuantity)
    ) {
      return "square-fill-blue";
    } else {
      return "square-partial-yellow";
    }
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyleCode",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
          true
        )

        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.rollSkuNumberOnClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "SERIAL#" : "Lot Number",
          "vendorBatchNumber",
          true
        )
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("rollNumber", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc#", "aisleInfoText", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", "", true)
        .setGraphDetails(true, this.graphValueProvider)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VerifyDate", "lastPhysicalInventoryVerificationDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    if (this.state.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("WHPO#", "warehousePurchaseOrderNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Container#", "containerNumber", true,)
          .setStyleDetails("right", "", "", "wt-2", "wt-2")
      );

      columns.push(
        new ColumnDefinition()
          .setDetails("IMEI#", "imeiNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );

      columns.push(
        new ColumnDefinition()
          .setDetails("Project#", "projectNumber", true,)
          .setStyleDetails("right", "", "", "wt-2", "wt-2")
      );

     
   
      columns.push(
        new ColumnDefinition()
          .setDetails("PALLET#", "palletNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2")
      );
    }

    columns.push(
      new ColumnDefinition()
        .setDetails("NoOfPallets", "numberOfPallets", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalArea", "totalArea", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    const inquiryDataList = this.state.inquiryDataList;
    let skuBatchInventoryBeanList = this.state.skuBatchInventoryBean;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    totalPages = this.state.totalPages;
    let pageSize = pageList.pageSize;
    // let totalCount = pageList.totalCount;
    // totalPages = Math.ceil(totalCount / pageSize);

    // totalPages = totalCount / pageSize;
    // totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;

    let is3PL = this.state.is3PL;
    let totalNumberOfpallets = this.state.totalNumberOfpallets;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricLookupHandler={this.state.fabricLookupHandler}
          customerLookupHandler={this.state.customerLookupHandler}
          warehouseLookupHandler={this.state.warehouseLookupHandler}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          customerCodeRef={this.customerCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          locationCodeOnChange={this.locationCodeOnChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
          showHideSecondHeader={this.showHideSecondHeader}
          onLogisticCustomerChange={this.onLogisticCustomerChange}
          logisticCustomerEnterKeyEventHandler={
            this.logisticCustomerEnterKeyEventHandler
          }
          displayAutoCompleteLogisticCustomerList={
            this.displayAutoCompleteLogisticCustomerList
          }
        />
        {this.state.isInquiryDatasFound ? (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null}
        {this.state.isInquiryDatasFound && this.state.is3PL ? (
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Total Number Of Pallets</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={totalNumberOfpallets}
                className="summary_input text-right"
                decimalScale={2}
                name={"totalNumberOfpallets"}
                disabled={true}
              />
            </Col>
          </Row>
        ) : null}

        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowRollSkuPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel3"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Sku Batch Maintainance Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  {" "}
                  {is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleCode"
                    placeholder="fabricStyleCode"
                    value={skuBatchInventoryBeanList.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="fabricStyleName"
                    placeholder="fabricStyleName"
                    value={skuBatchInventoryBeanList.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    placeholder="fabricStyleColorCode"
                    value={skuBatchInventoryBeanList.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Width</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="widthCode"
                    placeholder="widthCode"
                    value={skuBatchInventoryBeanList.widthCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>
                    {this.state.is3PL ? "Inventory#" : "RollSKU#"}
                  </FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="rollSkuNumber"
                    placeholder={
                      this.state.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
                    }
                    value={skuBatchInventoryBeanList.rollSkuNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Sku#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="skuNumber"
                    placeholder="skuNumber"
                    value={skuBatchInventoryBeanList.skuNumber}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>BinLoc#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="aisleInfoText"
                    placeholder="aisleInfoText"
                    value={skuBatchInventoryBeanList.aisleInfoText}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Loc#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="locationCode"
                    placeholder="locationCode"
                    value={skuBatchInventoryBeanList.locationCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>PO#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="purchaseOrderNumber"
                    placeholder="purchaseOrderNumber"
                    value={skuBatchInventoryBeanList.purchaseOrderNumber}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Receipt#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="purchaseOrderReceiptNumber"
                    placeholder="purchaseOrderReceiptNumber"
                    value={skuBatchInventoryBeanList.purchaseOrderReceiptNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Container#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="containerNumber"
                    placeholder="containerNumber"
                    value={skuBatchInventoryBeanList.containerNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>ReceivedDate</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="receivedDate"
                    placeholder="receivedDate"
                    value={skuBatchInventoryBeanList.receivedDate}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Roll#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="rollNumber"
                    placeholder="rollNumber"
                    value={skuBatchInventoryBeanList.rollNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>
                    {this.state.is3PL ? "SERIAL#" : "VendorBatch#"}
                  </FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="vendorBatchNumber"
                    placeholder="vendorBatchNumber"
                    value={skuBatchInventoryBeanList.vendorBatchNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>VendorSku#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="vendorSkuNumber"
                    placeholder="vendorSkuNumber"
                    value={skuBatchInventoryBeanList.vendorSkuNumber}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>ETADate</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="etaDate"
                    placeholder="etaDate"
                    value={skuBatchInventoryBeanList.etaDate}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="reserveCustomerCode"
                    placeholder="reserveCustomerCode"
                    value={skuBatchInventoryBeanList.reserveCustomerCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="reserveCustomerName"
                    placeholder="reserveCustomerName"
                    value={skuBatchInventoryBeanList.reserveCustomerName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Landed Cost</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="landedCost"
                    placeholder="landedCost"
                    className="summary_input text-right"
                    value={skuBatchInventoryBeanList.landedCost}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Fob Cost</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fobCost"
                    placeholder="fobCost"
                    className="summary_input text-right"
                    value={skuBatchInventoryBeanList.fobCost}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Cost</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="cost"
                    placeholder="cost"
                    className="summary_input text-right"
                    value={skuBatchInventoryBeanList.cost}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>OnHandQty</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="onHandQuantity"
                    placeholder="onHandQuantity"
                    className="summary_input text-right"
                    value={skuBatchInventoryBeanList.onHandQuantity}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>ReceivedQty</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="receivedQuantity"
                    placeholder="receivedQuantity"
                    className="summary_input text-right"
                    value={skuBatchInventoryBeanList.receivedQuantity}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  let warehouseLookupHandler = props.warehouseLookupHandler;
  let isDisableFields = props.isDisableFields;
  const fabricCodeRef = props.fabricCodeRef;
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };
  const locationCodeOnChange = (e) => {
    props.locationCodeOnChange(e);
  };
  return (
    <div>
      {props.is3PL ? (
        <div>
          <Row className="d-flex justify-content-left">
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={props.onLogisticCustomerChange}
                value={criteria.logisticCustomerCode}
                name="logisticCustomerCode"
                placeholder="customer"
                lookupRequired={true}
                lookupHandler={props.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={
                  props.logisticCustomerEnterKeyEventHandler
                }
                autoCompleteListData={
                  props.logisticCustomerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  props.displayAutoCompleteLogisticCustomerList
                }
                showAutoCompleteList={
                  props.showAutoCompleteLogisticCustomerList
                }
                disabled={false}
                isMandatory={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                value={criteria.logisticCustomerName}
                name="logisticCustomerName"
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={fabricCodeRef}
                name="fabricStyleCode"
                onChange={fabricCodeOnChange}
                value={criteria.fabricStyleCode}
                placeholder="item"
                lookupRequired={true}
                lookupHandler={props.fabricLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={fabricEnterKeyEventHandler}
                autoCompleteListData={props.fabricPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricList}
                showAutoCompleteList={props.showAutoCompleteFabricList}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleName"
                onChange={onChange}
                value={criteria.fabricStyleName}
                disabled={true}
              />
            </Col>

            <Col sm="1">
              <CollapseComponent
                isOpen={props.isCollapsible_open}
                onClick={(e) => props.showHideSecondHeader(e)}
              />
            </Col>
          </Row>
          {props.isCollapsible_open && (
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Color</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onFabricColourCodeChange}
                  name="colorCode"
                  placeholder="color"
                  value={criteria.colorCode}
                  lookupRequired={props.isShowColorLookup}
                  lookupHandler={props.colorLookupHandler}
                  enterKeyEventHandler={fabricColourEnterKeyEventHandler}
                  autoCompleteListData={
                    props.fabricColourPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteFabricColorList}
                  showAutoCompleteList={props.showAutoCompleteFabricColorList}
                  disabled={!props.isShowColorLookup}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
              {/* <FormLabel>Location</FormLabel> */}
               <FormLabel> {props.is3PL ? "WareHouse" : "Location"}</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={locationCodeOnChange}
                  name="locationCode"
                  // placeholder="location"
                  value={criteria.locationCode}
                  lookupRequired={true}
                  lookupHandler={warehouseLookupHandler}
                  enterKeyEventHandler={locationEnterKeyEventHandler}
                  autoCompleteListData={
                    props.locationPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteLocationList}
                  showAutoCompleteList={props.showAutoCompleteLocationList}
                  disabled={isDisableFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel> {props.is3PL ? "SERIAL#" : "LotNumber"} </FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onChange}
                  name="vendorBatchNumber"
                  placeholder="vendorBatchNumber"
                  value={criteria.vendorBatchNumber}
                  disabled={isDisableFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>
                  {" "}
                  {props.is3PL ? "WHPO#" : "warehousePurchaseorderNumber"}
                </FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onChange}
                  name="warehousePurchaseorderNumber"
                  placeholder="warehousePurchaseorderNumber"
                  value={criteria.warehousePurchaseorderNumber}
                  disabled={isDisableFields}
                />
              </Col>
            </Row>
          )}
          {props.isCollapsible_open && (
            <Row>
            
              <Col sm="1">
                <FormLabel>
                  {" "}
                  {props.is3PL ? "Container#" : "containerNumber"}
                </FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onChange}
                  name="containerNumber"
                  placeholder="containerNumber"
                  value={criteria.containerNumber}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>
                  {" "}
                  {props.is3PL ? "Project#" : "projectNumber"}{" "}
                </FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onChange}
                  name="projectNumber"
                  placeholder="projectNumber"
                  value={criteria.projectNumber}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel> {props.is3PL ? "IMEI#" : "imeiNumber"}</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onChange}
                  name="imeiNumber"
                  placeholder="imeiNumber"
                  value={criteria.imeiNumber}
                  disabled={isDisableFields}
                />
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <div>
          <Row className="d-flex justify-content-left">
            <Col sm="1">
              <FormLabel>FabricStyle</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={fabricCodeRef}
                name="fabricStyleCode"
                onChange={fabricCodeOnChange}
                value={criteria.fabricStyleCode}
                placeholder="item"
                lookupRequired={true}
                lookupHandler={props.fabricLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={fabricEnterKeyEventHandler}
                autoCompleteListData={props.fabricPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricList}
                showAutoCompleteList={props.showAutoCompleteFabricList}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleName"
                onChange={onChange}
                value={criteria.fabricStyleName}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={onFabricColourCodeChange}
                name="colorCode"
                placeholder="color"
                value={criteria.colorCode}
                lookupRequired={props.isShowColorLookup}
                lookupHandler={props.colorLookupHandler}
                enterKeyEventHandler={fabricColourEnterKeyEventHandler}
                autoCompleteListData={
                  props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricColorList}
                showAutoCompleteList={props.showAutoCompleteFabricColorList}
                disabled={!props.isShowColorLookup}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Location</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={locationCodeOnChange}
                name="locationCode"
                placeholder="location"
                value={criteria.locationCode}
                lookupRequired={true}
                lookupHandler={warehouseLookupHandler}
                enterKeyEventHandler={locationEnterKeyEventHandler}
                autoCompleteListData={props.locationPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteLocationList}
                showAutoCompleteList={props.showAutoCompleteLocationList}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col>
              <CollapseComponent
                isOpen={props.isCollapsible_open}
                onClick={(e) => props.showHideSecondHeader(e)}
              />
            </Col>
          </Row>
          {props.isCollapsible_open && (
            <Row>
              <Col sm="1">
                <FormLabel>{props.is3PL ? "SERIAL#" : "LotNumber"}</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onChange}
                  name="vendorBatchNumber"
                  placeholder="vendorBatchNumber"
                  value={criteria.vendorBatchNumber}
                  disabled={isDisableFields}
                  isMandatory={true}
                />
              </Col>
            </Row>
          )}
        </div>
      )}
    </div>
  );
}

function SkuBatchInventoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SkuBatchInventory {...props} name="" /> <br />
    </div>
  );
}

export default SkuBatchInventoryInquiry;
